#!/usr/bin/env node
import { Command } from 'commander'

import { CLUSTERS, DEFAULT_CLUSTER } from '../constants'
import { createServiceCommand } from './commands/create-service'
import { deployCommand } from './commands/deploy'
import { initCommand } from './commands/init'
import { initClaudeCommand } from './commands/init-claude'
import { loginCommand } from './commands/login'
import { logoutCommand } from './commands/logout'
import { pullCommand } from './commands/pull'
import { useCommand } from './commands/use'

const { version } = require('../../package.json')

// The command-line program. Reached only through `bin/flowrunner.js` — the package's own entry point is
// `src/index.ts`, which exports the operations and parses nothing.
const program = new Command()

program
  .name('flowrunner')
  .description('Flowrunner CLI for Custom extension management')
  .version(version)

program
  .command('init')
  .argument('[template]', 'Template to scaffold a first service from; omit to create just the project')
  .description('Create a FlowRunner extensions project (package.json, flowrunner.json, .gitignore)')
  .option('-d, --dir <path>', 'Directory to create the project in (defaults to the current one)')
  .option('-s, --server <target>', 'Server to point the project at: prod, dev, local, or a full URL' +
    ` (default: ${ DEFAULT_CLUSTER } — ${ CLUSTERS[DEFAULT_CLUSTER] })`)
  .option('--id <id>', 'Service id, when a template is given (skips that prompt)')
  .option('--name <name>', 'Display name, when a template is given (skips that prompt)')
  .option('--set <name=value...>', 'Answer any prompt the template declares (repeatable)')
  .option('-y, --yes', 'Accept every default and ask nothing')
  .option('--no-install', 'Skip the npm install at the end')
  .option('--no-git', 'Skip initialising a git repository and making the first commit')
  .option('--no-tests', 'Skip the unit-test harness (jest config + sandbox/)')
  .action(initCommand)

program
  .command('init-claude')
  .description('Wire the FlowRunner agent instructions into this project\'s Claude setup')
  .option('-d, --dir <path>', 'Project directory to wire up (defaults to the current one)')
  .action(initClaudeCommand)

program
  .command('login')
  .description('Log in to a FlowRunner server via browser-based authorization')
  .option('-s, --server <target>', 'prod, dev, local, or a full URL (defaults to serverUrl in flowrunner.json)')
  .action(loginCommand)

program
  .command('logout')
  .description('Log out and revoke stored token')
  .action(logoutCommand)

program
  .command('create-service')
  .alias('cs')
  .argument('[template]', 'Template to generate from; omit to choose one interactively')
  .description('Scaffold a new service into services/ from a code template')
  .option('--id <id>', 'Service id (skips that prompt)')
  .option('--name <name>', 'Display name (skips that prompt)')
  .option('--set <name=value...>', 'Answer any prompt the template declares (repeatable)')
  .option('-y, --yes', 'Accept every default and ask nothing')
  .option('--list', 'List the available templates and exit')
  .action(createServiceCommand)

program
  .command('use')
  .argument('[target]', 'Which server: prod, dev, local — or a full URL. Omit to list them.')
  .description('Point this project at a Flowrunner server, detaching any login from the previous one')
  .action(useCommand)

program
  .command('deploy')
  .description('Deploy services from this project to the workspace')
  .option('-s, --service <id...>', 'Service to deploy (repeatable). Omit to be asked.')
  .option('--all', 'Deploy every service in this project')
  .option('--force', 'Upload even a service the workspace already has byte-for-byte')
  .action(deployCommand)

program
  .command('pull')
  .alias('sync-services')
  .description('Download the workspace\'s services into services/ so they can be edited and deployed back')
  .option('-s, --service <id...>', 'Service to pull (repeatable). Omit to be asked.')
  .option('--all', 'Pull every service in the workspace')
  .option('--force', 'Overwrite a services/<id>/ folder that already exists')
  .action(pullCommand)

program.parse()
